import { render, staticRenderFns } from "./notify.vue?vue&type=template&id=0a0e61a1&"
import script from "./notify.vue?vue&type=script&lang=js&"
export * from "./notify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports